/*
 * School Management System API
 * APIs for managing branches, employees, students, receipts, etc.
 *
 * OpenAPI spec version: 1.0.0
 * Contact: tejabhargavpodila@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.54
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";
import Employee from '../model/Employee';
import Error from '../model/Error';

/**
* Employees service.
* @module api/EmployeesApi
* @version 1.0.0
*/
export default class EmployeesApi {

    /**
    * Constructs a new EmployeesApi. 
    * @alias module:api/EmployeesApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the employeesPost operation.
     * @callback moduleapi/EmployeesApi~employeesPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Employee{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a new employee
     * Add a new employee to the system.
     * @param {module:model/Employee} body 
     * @param {module:api/EmployeesApi~employeesPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    employeesPost(body, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling employeesPost");
      }

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Employee;

      return this.apiClient.callApi(
        '/employees', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}